// extracted by css-extract-rspack-plugin
export default {"actionButton":"JRDYz"};